module.exports = __WEBPACK_EXTERNAL_MODULE_2__;


//////////////////
// WEBPACK FOOTER
// external "isogd-document-rest"
// module id = 2
// module chunks = 0